import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Michigan = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Michigan Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Disclosure form required detailing physical condition of the
          property.
        </Text>

        <Text style={styles.listItem}>
          2. Seller's Disclosure Statement: Required for residential sales.
        </Text>

        <Text style={styles.listItem}>
          3. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          4.{' '}
          <Text style={styles.underline}>
            Seller's Property Disclosure Statement
          </Text>{' '}
          – Sellers must provide a comprehensive disclosure of the property's
          condition and advise the buyer to conduct a professional inspection.
        </Text>
      </View>
    </View>
  );
};

export default Michigan;
